import styled from 'styled-components'
import { GRAYSCALE_500, NEUTRAL_100 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

export const Container = (styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 16px 12px;
  border-radius: 12px;
  border: 1px solid ${NEUTRAL_100};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const EmptyContainer = (styled.div`
  padding: 64px 0px;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const EmptyText = (styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${GRAYSCALE_500};
  text-align: center;
  width: 75%;
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any

export const DividerLine = (styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`) as any // eslint-disable-line @typescript-eslint/no-explicit-any
